import type { TranslationContent } from '@CS/components/TranslationProvider/types';

import MinusIcon from '@/assets/images/icons/minus.svg?component';
import PlusIcon from '@/assets/images/icons/plus.svg?component';

import { Content } from '@CS/components/Form';
import { useTranslation } from '@CS/hooks';

import {
  FieldContainer,
  FieldLabel,
  FieldInput,
  FieldControl,
  FieldError,
  InputField
} from './InputFieldNumber.styles';

import {
  useWatch,
  type Control,
  type FieldValues,
  type UseFormRegisterReturn
} from 'react-hook-form';

interface InputFieldNumberProps {
  onChange?: (value: number) => void;
  register: UseFormRegisterReturn;
  getValues?: () => FieldValues;

  control: Control<any>;
  placeholder?: string;
  fieldError?: string;
  onBlur?: () => void;
  disabled?: boolean;
  maxValue?: number;

  error?: boolean;
  width?: number;
  label?: string;
  last?: boolean;
  type?: string;
  name: string;
  id: string;
}

export const InputFieldNumber = ({
  onChange = () => void 0,
  onBlur = () => void 0,
  placeholder = '',
  disabled = false,
  type = 'number',
  fieldError = '',
  maxValue = 10,
  error = false,
  last = false,
  width = 100,
  register,
  control,
  id = '',
  label,
  name
}: InputFieldNumberProps) => {
  const value = useWatch({ name: id, control });
  const Translations = Content as TranslationContent;
  const fieldLabel = useTranslation(Translations[name]);
  fieldError ||= useTranslation(Translations[`${name}Error`]);

  const onChangeValue = (up: boolean) => {
    let next = value;

    if (up) {
      if (maxValue > next) next++;
    } else if (next > 1) next--;

    onChange(next);
  };

  return (
    <FieldContainer width={width} last={last} style={{ paddingBottom: "6px" }}>
      <FieldLabel htmlFor={name}>{label || fieldLabel}</FieldLabel>

      <InputField>
        <FieldControl
          type="button"
          disabled={value <= 1}
          onTouchStart={() => {
            onChangeValue(false);
          }}
        >
          <MinusIcon />
        </FieldControl>

        <FieldInput
          readOnly
          id={name}
          type={type}
          {...register}
          onBlur={onBlur}
          disabled={disabled}
          placeholder={placeholder}
        />

        <FieldControl
          type="button"
          disabled={value >= maxValue}
          onTouchStart={() => {
            onChangeValue(true);
          }}
        >
          <PlusIcon />
        </FieldControl>
      </InputField>

      {error && <FieldError>{fieldError}</FieldError>}
    </FieldContainer>
  );
};
